module.exports = __webpack_public_path__ + "static/media/ic-chevron-right.472a6dcf.svg";